import {IProdGridConfig} from 'prod-grid'
import {DipGridFilter} from "../dip/dip-grid-filter/dip-grid-filter";

export class ProdGridConfig {
  config: IProdGridConfig = {
    clientFilterComponent: DipGridFilter
  }
}
